const CompanyStory = () => (
  <section className="relative bg-dp py-28 overflow-hidden">
    {/* Subtle grid texture */}
    <div
      className="absolute inset-0 opacity-[0.025]"
      style={{
        backgroundImage:
          'linear-gradient(rgba(0,217,255,1) 1px, transparent 1px), linear-gradient(90deg, rgba(0,217,255,1) 1px, transparent 1px)',
        backgroundSize: '80px 80px',
      }}
    />

    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      {/* Top rule + label */}
      <div className="flex items-center gap-4 mb-16 scroll-reveal">
        <span className="h-[1px] flex-1 bg-gradient-to-r from-transparent via-[var(--bd)] to-transparent" />
        <span className="text-[#00D9FF] text-[11px] font-bold tracking-[3px] uppercase px-4">Our Story</span>
        <span className="h-[1px] flex-1 bg-gradient-to-r from-transparent via-[var(--bd)] to-transparent" />
      </div>

      {/* Main layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-start">

        {/* Left: Editorial content */}
        <div className="scroll-reveal scroll-from-left">
          <h2 className="text-4xl md:text-5xl font-black text-[var(--tp)] leading-tight tracking-tight mb-8">
            Two Decades of Work
            <br />
            <span className="text-[#00D9FF]">Done Right.</span>
          </h2>

          <div className="space-y-6 text-[var(--ts)] text-[15px] leading-relaxed">
            <p>
              DOC Electric LLC was founded in Kalamazoo, Michigan with a simple conviction: that electrical work should be
              done with the same care you&apos;d give your own home. What started as a small operation rooted in a faith-based
              commitment to honest service has grown into one of southwest Michigan&apos;s most trusted electrical contractors.
            </p>
            <p>
              Over 20 years, we&apos;ve wired new homes, upgraded aging panels, installed generators before winter storms hit,
              and helped families make smart energy upgrades — all without shortcuts, hidden charges, or sloppy work.
              Our license is on every job. Our name is on every truck. And our word means something.
            </p>
            <p>
              As an employee-owned company, every technician you meet has a stake in the quality of the work. There are
              no subcontracted surprises. The people who quote the job are the people who do the job.
            </p>
          </div>

          {/* Pull quote */}
          <div className="mt-12 border-l-2 border-[#00D9FF] pl-6">
            <p className="text-[var(--tp)] text-xl font-semibold leading-snug italic">
              &ldquo;We treat every home like it&apos;s our own — because to someone,
              it is.&rdquo;
            </p>
            <span className="mt-3 block text-[#00D9FF] text-[12px] font-bold tracking-widest uppercase">
              — DOC Electric LLC
            </span>
          </div>
        </div>

        {/* Right: image with floating badges */}
        <div className="relative scroll-reveal scroll-from-right">
          {/* Main image */}
          <div className="relative rounded-xl overflow-hidden aspect-[4/5]">
            <img
              src="https://public.readdy.ai/ai/img_res/b21b0aae04d6e604831ba07ccd14d687.jpg"
              alt="DOC Electric professional at work"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060E1C]/50 via-transparent to-transparent" />
          </div>

          {/* Floating badge — top left */}
          <div className="absolute -top-5 -left-5 bg-cr border border-[var(--bd)] rounded-xl p-4 shadow-xl">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center bg-[#00D9FF]/10 rounded-lg">
                <i className="ri-heart-fill text-[#00D9FF] text-lg" />
              </span>
              <div>
                <div className="text-[var(--tp)] font-bold text-[13px] whitespace-nowrap">Faith-Based</div>
                <div className="text-[var(--tm)] text-[11px]">Our guiding foundation</div>
              </div>
            </div>
          </div>

          {/* Floating badge — bottom right */}
          <div className="absolute -bottom-6 -right-5 bg-cr border border-[var(--bd)] rounded-xl p-4 shadow-xl">
            <div className="flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center bg-[#00D9FF]/10 rounded-lg">
                <i className="ri-team-fill text-[#00D9FF] text-lg" />
              </span>
              <div>
                <div className="text-[var(--tp)] font-bold text-[13px] whitespace-nowrap">Employee-Owned</div>
                <div className="text-[var(--tm)] text-[11px]">Every tech has a stake</div>
              </div>
            </div>
          </div>

          {/* Floating badge — top right overlap */}
          <div className="absolute top-8 -right-4 bg-[#00D9FF] rounded-xl px-4 py-3 shadow-lg">
            <div className="text-[#0A1628] font-black text-2xl leading-none">20+</div>
            <div className="text-[#0A1628]/70 text-[11px] font-bold uppercase tracking-wider">Years</div>
          </div>
        </div>
      </div>

      {/* Bottom stats row */}
      <div className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-px bg-[var(--bd)] rounded-xl overflow-hidden border border-[var(--bd)] scroll-reveal">
        {[
          { value: '20+', label: 'Years in Business', icon: 'ri-calendar-2-fill' },
          { value: '1,000+', label: 'Projects Completed', icon: 'ri-flashlight-fill' },
          { value: '100%', label: 'Code-Compliant Work', icon: 'ri-shield-check-fill' },
          { value: 'SW MI', label: 'Serving Southwest Michigan', icon: 'ri-map-pin-2-fill' },
        ].map((stat) => (
          <div key={stat.label} className="bg-dp px-8 py-8 flex flex-col items-center text-center">
            <span className="w-10 h-10 flex items-center justify-center mb-3">
              <i className={`${stat.icon} text-[#00D9FF] text-xl`} />
            </span>
            <div className="text-[var(--tp)] font-black text-3xl mb-1">{stat.value}</div>
            <div className="text-[var(--tm)] text-[12px] font-medium leading-tight">{stat.label}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default CompanyStory;
